module.exports = __webpack_public_path__ + "static/media/GreatSouthernHerald-socshare-min.4bf82ca6.jpg";